module.exports = __webpack_public_path__ + "static/media/instructivosc4.76610fe7.png";